<template>
  <div v-if="value" style="color: #4caf50">Zapnuto</div>
  <div v-else style="color: #f44336">Vypnuto</div>
</template>

<script>
export default {
  name: 'EnabledDisabled',
  props: {
    value: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
